// Dependencies
import React from 'react';
import radium from 'radium';
import shipmentTypesEnum from "../../../components/shipment-type/shipment-types-enum";
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SelectedShipmentType(props) {
	const context = React.useContext(ThemeContext);
	const icons = {
		CARRY: 'building',
		POST: 'envelope-o',
		EMAIL: 'at',
		PICKUP: 'building',
	}
	const style = {
		shipmentTypeContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			margin: '0 0 1em',
			height: '2em',
			alignItems: 'center'
		},
		shipmentTotal: {
			alignSelf: 'flex-end',
			fontWeight: 800,
			lineHeight: 'inherit',
		},
		label: {
			fontWeight: 'normal',
			display: 'flex',
			alignItems: 'center',
		},
		icon: {
			marginRight: '.3em',
			color: context.themeManager.value('shipment-type-icon', 'color', 'fg-color-icon-highlight'),
			fontSize: context.themeManager.value('shipment-type-icon', 'font-size', 'font-size-300'),
		}
	}
	return (
		<div>
			<div style={style.shipmentTypeContainer}>
				<span style={style.label}>
					<FontAwesomeIcon
						icon={icons[props.selectedShipmentType]}
						style={style.icon}
					/>
					{shipmentTypesEnum[props.selectedShipmentType]}</span>
				<span className="price" style={style.shipmentTotal}>{props.selectedShipmentTypeFee.money.value.toFixed(2)} €</span>
			</div>
		</div>
	);
}

export default radium(SelectedShipmentType);
